import { useState } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import ViewContainer from "components/ViewContainer/ViewContainer";
import ButtonPrimary from "components/Buttons/ButtonPrimary";
import { sendPasswordResetConfirmation } from "services/http/users";

const styles = (_theme) => ({
  fieldGrid: {
    marginBottom: 12,
  },
});

const useStyles = makeStyles(styles);

const PasswordReset = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = props;
  const { t } = useTranslation();

  const [values, setValues] = useState({
    email: "",
  });

  const [errors, setErrors] = useState(null);

  const handleInputChange = (event) => {
    let { value, name } = event.target;

    if (["email"].indexOf(name) > -1) {
      value = value.toLowerCase();
    }

    setValues({
      ...values,
      [name]: value,
    });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    const request = {
      data: {
        email: values.email,
      },
    };

    sendPasswordResetConfirmation(request).then(
      (_response) => {
        enqueueSnackbar(
          t("Salasanan palautuslinkki on lähetetty sähköpostiisi"),
          { variant: "success" },
        );
        navigate("/auth/login");
      },
      (_error) => {
        setErrors(true);
        enqueueSnackbar(t("Pyyntö epäonnistui. Yritä uudelleen myöhemmin."), {
          variant: "error",
        });
      },
    );
  };

  return (
    <ViewContainer title={t("Palauta salasana")}>
      <form className={classes.root} onSubmit={onSubmit}>
        <Grid container className={classes.container}>
          <Grid className={classes.fieldGrid} size={{ xs: 12 }}>
            <Typography variant="subtitle1">
              {t("Sähköposti / käyttäjätunnus")}
            </Typography>
            <TextField
              required
              fullWidth
              id="password-reset-email"
              name="email"
              value={values.email}
              onChange={handleInputChange}
              type="email"
              margin="dense"
              variant="outlined"
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Grid
              container
              direction="row"
              sx={{ justifyContent: "center", alignItems: "flex-end" }}
            >
              <Grid size={12}>
                <ButtonPrimary type="submit">
                  {t("Palauta salasana")}
                </ButtonPrimary>
              </Grid>
            </Grid>
          </Grid>

          {errors ? (
            <Typography variant="subtitle2" color="error" gutterBottom>
              {t(
                "Salasanan palauttaminen epäonnistui. Tarkista sähköpostiosoite/käyttäjätunnus",
              )}
            </Typography>
          ) : null}
        </Grid>
      </form>
    </ViewContainer>
  );
};

export default PasswordReset;
